function initAnnoucementSlider() {
  var swiper = new Swiper(".umySwiper", {
    autoplay: {
      delay: 4000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 1000,
    slidesPerView: 1,
  });
}
function startCountdownTimer() {
  setInterval(function () {
    var d = new Date();
    var hours = 23 - d.getHours();
    if (hours < 10) {
      hours = '0' + hours;
    }
    var min = 59 - d.getMinutes();
    if (min < 10) {
      min = '0' + min;
    }
    var sec = 59 - d.getSeconds();
    if (sec < 10) {
      sec = '0' + sec;
    }
    let timeElements = document.getElementsByClassName('aus_timerr');
    for (let i = 0; i < timeElements.length; i++) {
      timeElements[i].innerHTML = `${hours}:${min}:${sec}`;
    }
  }, 1000);
}

// Call the function to start the timer
startCountdownTimer();
document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});
function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 4,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}

// Call the function
initializeReviewsSwiper();
function initTrandingSlider() {
    var trandingSlider = new Swiper('.u-product-upsell-container', {
        spaceBetween: 20,
        slidesPerView: 2,
        autoplay: {
            delay: 300000,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    });
}

initTrandingSlider();
